// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cogDatabaseInset16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog-database-inset': IconCogDatabaseInset;
    }
}

/**
 * The icon component for the 'cogDatabaseInset' icon
 */
export class IconCogDatabaseInset extends IconSvg {
    public constructor() {
        super(cogDatabaseInset16X16);
    }
}

registerIconSvg('icon-cog-database-inset', IconCogDatabaseInset);
export const iconCogDatabaseInsetTag = 'nimble-icon-cog-database-inset';
